__turbopack_context__.v({
  "attributesContainer": "styles-module__M799tW__attributesContainer",
  "brandName": "styles-module__M799tW__brandName",
});
